export default "__VITE_ASSET__C7vqwd72__"